import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ITableModel } from '../table/model/tableModel';
import { CommonService } from '../../services/commen/commen.services';
import { Http } from '@angular/http';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { TranslateConfigService } from '../../../theme/home/translateConfig.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { Helpers } from '../../../helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileDetectionService } from '../../services/mobile-detection.service';
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-attachments-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnInit,OnChanges {

  static that: AttachmentListComponent;
  selectedLang: any;
  selectedCountry: any;
  isList: boolean;
  @Input() Hidebackbutton: boolean = false;
  @Input() Hideclosebutton: boolean = false;
  isMobileView: boolean;
  @Output() onViewTypeOutput = new EventEmitter<any>();
  @Output() attachmentSavedBool = new EventEmitter<any>();
  @Input() canEdit: boolean = true;//added by BURHAN - 13-May-2026
  @Input() requiresPermission: boolean = false;//added by BURHAN - 13-May-2026
  tableDetails: ITableModel = {
    data: [],
    columnDetails: [
      { columnName: 'fileName', dataFieldName: 'fileFullName', divType: 'file' },
      { columnName: 'Document Type', dataFieldName: 'DocumentType' },
      { columnName: 'Uploaded Date', dataFieldName: 'updatedDate' },
      { columnName: 'Size', dataFieldName: 'size', },
      { columnName: 'fileAction', dataFieldName: '', divType: 'fileAction' },
    ],
    isColumnNameShow: false
  };
  orderDetails: any = {
    cardName: "Attachments",
    id: 'Attachments',
    listOfRow: [
      [{
        dataField: 'fileFullName',
        divType: "isUserDetails",
        isIcon: true,
        logoIcon: '../../../../assets/driver/JPG_Icon.png'
      }],
    ],
    footer: {
      actionBtn: true,
      // actionList: [
      //   { label: 'Delete', icon: 'pi pi-fw pi-trash', visible: this.commonService.CheckHasRight('DELETE', '') },
      //   { label: 'Download', icon: 'pi pi-download', visible: this.commonService.CheckHasRight('VIEW', '') },
      // ]
      actionList: []
    }
  };
  @Input() DocumentId: any;
  @Input() DocumentType: any;
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  documentList: any[];
  modalRef: any;
  viewType: string = "table";

  constructor(
    private commonService: CommonService,
    private anghttp: Http,
    private _appService: appService,
    private toastr: ToastrService,
    private http: HttpClient,
    private service: TranslateConfigService,
    private translate: TranslateService,
    private modalService: NgbModal,
    private mobileDetectionService: MobileDetectionService,
  ) {
    AttachmentListComponent.that = this;
    let language = this.translate.getBrowserLang();
    let value = localStorage.getItem(LNG_KEY);
    if (value === "" || value === null || value === undefined) {
      this.translate.setDefaultLang(language);
      this.selectedLang = language;
    } else {
      this.service.setLanguage(value);
      this.selectedLang = value;
    }
    let val = localStorage.getItem(LNG_KEY);
  }

  ngOnInit() {
    this.canEdit = this.toBoolean(this.canEdit);//added by BURHAN - 13-May-2026
    this.getAttachedDocument();
    this.setupTableActions();//added by BURHAN - 13-May-2026
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DocumentId'] && changes['DocumentId'].currentValue) {
      this.DocumentId = changes['DocumentId'].currentValue;
      this.getAttachedDocument();
    }
    //added by BURHAN - 13-May-2026
    if (changes['canEdit']) {
      this.canEdit = this.toBoolean(changes['canEdit'].currentValue);
      this.setupTableActions();
    }
    //end by BURHAN
  }

  ngAfterViewInit() {
    this.getAttachedDocument();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobileView = this.mobileDetectionService.checkScreenSize();
  }

  Cancel() {
    this.close.emit()
  }

  onViewtypeChange(type) {
    this.viewType = type;
    this.onViewTypeOutput.emit(type);
  }

  getAttachedDocument(id = this.DocumentId, type = this.DocumentType) {
    Helpers.setLoading(true);
    this._appService
      .GetByTwoId("Common", "GetDocumentListById", id, type)
      .subscribe((response) => {
        if (response) {
          response.map(x => {
            x.fileFullName = x.FileName ? (x.FileName.split("_")[1] + '.' + x.FileExtension) : null;
            x.FilePath = environment.apiUrl + x.docPath;
          })
        }
        this.documentList = response;
        this.tableDetails = { ...this.tableDetails, data: this.documentList};  // added by yash 08-08-2026
        Helpers.setLoading(false);
      },
        (err) => {
          Helpers.setLoading(false);
          var ErrorMsg = this.translate.instant("READYTODISPATCH.Erroroccurred");
          this.toastr.error(ErrorMsg, "error");
        })
  }

  downloadFile(event) {
    const fileUrl = event;
    this.http
      .get(fileUrl, { responseType: 'blob' })
      .subscribe((response: any) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'filename.pdf'; // Set desired filename
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  onActionClick({ row, actionName }) {
    if (actionName == 'Download') {
      // this.downloadFile(row.FilePath)
      // commented and Added by priya date-17/01/2025
      if (row.FilePath) {
        window.open(row.FilePath, '_blank');
      } else {
        window.open(row.FilePath, '_blank');
      }
    } else if (actionName == 'Delete') {
      this.deleteFile(row);
    }
  }

  deleteFile(row: any) {
    this.commonService.deleteFileId(row.Id)
      .then((data) => {
        const index = this.documentList.findIndex(x => x.Id === row.Id);
        if (index !== -1) {
          this.documentList.splice(index, 1);
        }
        this.tableDetails.data = this.documentList;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  onFileSelected(event: any): void {
    const files = (event.target as HTMLInputElement).files;
    const todaysDate = this.commonService.formatSelectedDate(new Date());
    if (!files || files.length === 0) {
      this.toastr.error(this.translate.instant("Attachment.UploadFileError"), "error");
      return;
    }
    for (const file of Array.from(files)) {
      console.log('file', file, event.target)
      if (this.commonService.isValidFileTypeV2(file) && this.commonService.isFileSizeExceeded(file) && this.commonService.isValidFileName(file)) {
        this.tableDetails.data.unshift({
          fileFullName: file.name, updatedDate: todaysDate, size: Math.floor(file.size / 1024) + 'KB'
        });
        this.UploadDocument(file);
        this.tableDetails = { ...this.tableDetails, data: this.tableDetails.data }
      }
    }
  }

  UploadDocument(event, type: any = this.DocumentType) {
    const selectedFile = event;
    const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
    const apiUrl =
      environment.apiUrl +
      "/api/Document/UploadAttachment?ReferenceId=" +
      this.DocumentId +
      "&TransectionType=" +
      type +
      "&ParentId=" +
      null;
    const req1 = this.anghttp.post(apiUrl, formData, options).subscribe(
      (response) => {
        this.toastr.success(
          this.translate.instant("Attachment.AttachmentUploadSuccess"),
          "success"
        );
        this.getAttachedDocument()
        this.attachmentSavedBool.emit(true);
      },
      (err) => {
        this.toastr.error(this.translate.instant("Attachment.UploadError"), "error");
      }
    );
  }

  //added by BURHAN - 13-May-2026
  setupTableActions() {
    const actions = [];

    // ye ab proper boolean check karega
    if (this.canEdit === true) {
      // console.log('Delete option push kar diya');
      actions.push({
        label: 'Delete',
        icon: 'pi pi-fw pi-trash',
        command: null
      });
    }

    actions.push({
      label: 'Download',
      icon: 'pi pi-download',
      command: null
    });

    this.orderDetails.footer.actionList = actions;

    this.tableDetails.columnDetails = [
      { columnName: 'fileName', dataFieldName: 'fileFullName', divType: 'file' },
      { columnName: 'Document Type', dataFieldName: 'DocumentType' },
      { columnName: 'Uploaded Date', dataFieldName: 'updatedDate' },
      { columnName: 'Size', dataFieldName: 'size' },
      { columnName: 'fileAction', dataFieldName: '', divType: 'fileAction' },
    ];
  }

  private toBoolean(value: any): boolean {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'string') {
      return value === '1' || value.toLowerCase() === 'true';
    }
    if (typeof value === 'number') return value === 1;
    return !!value;
  }
  //end by BURHAN
}
